// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kOKZL","left":"styles_left__2b_Sz"};